import { useIonToast } from '@ionic/react';

export default function useIonicToast() {
  const [present] = useIonToast();

  const presentIonToast = (
    msg: string,
    role?: 'error' | 'success' | 'regular'
  ) => {
    present({
      duration: 5000,
      position: 'top',
      message: msg,
      buttons: [
        {
          text: 'dismiss',
          role: 'cancel',
        },
      ],
      color:
        role === 'error'
          ? 'danger'
          : role === 'success'
            ? 'success'
            : 'primary',
    });
  };

  return { presentIonToast };
}
